type AppEnv = {
  supabaseUrl: string
  supabaseAnonKey: string
  backendUrl: string
  appName: string
  appLogo: string
  isProduction: boolean
}

function readRequired(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    if (import.meta.env.PROD) {
      throw new Error(
        `Missing required env var ${name}. Set it in your deployment environment.`,
      )
    }
    console.warn(
      `[env] ${name} is not set. Some features (Supabase, auth) will be disabled until you fill .env.local.`,
    )
    return ''
  }
  return value
}

export const env: AppEnv = {
  supabaseUrl: readRequired('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: readRequired(
    'VITE_SUPABASE_ANON_KEY',
    import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
  // Backend URL — sau khi migrate edge functions sang Hono backend. Dev:
  // http://localhost:8787. Prod: domain backend deploy (vd Railway/Render).
  // Fallback về '' nếu chưa set → FE log error rõ ràng khi gọi shipping-*.
  backendUrl:
    import.meta.env.VITE_BACKEND_URL || (import.meta.env.DEV ? 'http://localhost:8787' : ''),
  appName: import.meta.env.VITE_APP_NAME || '4K Decor CRM',
  // Tên file logo trong thư mục /public (vd 'logo-4k-decor.jpg'). Đường dẫn
  // tuyệt đối từ root site → đổi thương hiệu chỉ cần thả file + set biến này.
  appLogo: import.meta.env.VITE_APP_LOGO || '/logo-4k-decor.jpg',
  isProduction: import.meta.env.PROD,
}

export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey)
